<template>
  <div class="faq">
    <h2>热门问答</h2>
    <div class="faq-item" v-for="item in list" :key="item.id || item.q">
      <h3>{{ item.q }}</h3>
      <p>{{ item.a }}</p>
    </div>
    <div class="empty" v-if="loaded && !list.length">暂无问答</div>
  </div>
</template>

<script>
import req from "../../utils/index";

const FALLBACK_LIST = [
  {
    q: "旷真律师事务所是做什么的？",
    a: "旷真律师事务所于2009年成立于湖南长沙，目前已在全国30余座城市设所，拥有千余名法律专业人士。旷真秉持精益法律服务的使命，致力于法律服务产品化、组织化和规模化。",
  },
  {
    q: "旷真主要提供哪些法律服务？",
    a: "旷真从专注建材行业应收款发展而来，目前业务涵盖多行业应收款、债务重组、婚姻家事、继承传承、刑事辩护、物业法律顾问等。服务以客户为中心，覆盖咨询、谈判、诉讼和执行等环节。",
  },
  {
    q: "婚姻家事业务可以处理哪些问题？",
    a: "婚姻家事业务包括传统婚恋法律服务、涉外家事法律服务，以及继承与传承法律服务。常见事项有婚前协议、离婚及离婚后财产纠纷、子女抚养、涉外婚姻与继承、遗嘱规划、遗产分割等。",
  },
  {
    q: "刑事辩护可以提供哪些帮助？",
    a: "刑事业务覆盖刑事危机应对、举报与控告、调解和解谅解、刑事辩护、刑事申诉与死刑复核，以及快速取保候审。律师会根据侦查、审查起诉和审判等阶段，为当事人制定辩护方案并同步进展。",
  },
  {
    q: "如何查看旷真办理过的案例？",
    a: "打开一级菜单「旷真案例」即可查看全部案例，页面内可按家事、刑事、应收款分类浏览。每条案例展示标题和内容简介，点击即可阅读全文。",
  },
  {
    q: "如何联系旷真咨询？",
    a: "可通过「联系我们」查看各地办公地址和电话。总部地址：长沙市芙蓉区解放西路188号国金中心T1号写字楼40层09-16单元。联系电话：0731-89802222。",
  },
];

export default {
  data() {
    return {
      list: [],
      loaded: false,
    };
  },
  created() {
    this.loadFaq();
  },
  methods: {
    stripHtml(html) {
      return String(html || "")
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<[^>]+>/g, " ")
        .replace(/&nbsp;/gi, " ")
        .replace(/&ldquo;|&rdquo;/gi, '"')
        .replace(/&mdash;/gi, "—")
        .replace(/&middot;/gi, "·")
        .replace(/&amp;/gi, "&")
        .replace(/\s+/g, " ")
        .trim();
    },
    mapRows(rows) {
      return (rows || [])
        .map((item) => {
          // 答案取内容字段；兼容旧数据无正文时回退描述
          const body = this.stripHtml(item.textcontent || item.content);
          const summary = item.summary && String(item.summary).trim();
          return {
            id: item.id,
            q: item.title,
            a: body || summary || "",
          };
        })
        .filter((item) => item.q && item.a);
    },
    loadFaq() {
      this.loaded = false;
      req("get", "api/base/getcate?pid=2", {})
        .then((cateRes) => {
          const faqCate = (cateRes.data || []).find(
            (item) => item.name === "常见问答"
          );
          if (!faqCate) {
            this.list = FALLBACK_LIST;
            this.loaded = true;
            return null;
          }
          return req("post", "api/base/articlelist", {
            Cid: String(faqCate.id),
            Page: 1,
            Limit: 100,
          });
        })
        .then((res) => {
          if (!res) return;
          const mapped = this.mapRows(res.data);
          this.list = mapped.length ? mapped : FALLBACK_LIST;
          this.loaded = true;
        })
        .catch(() => {
          this.list = FALLBACK_LIST;
          this.loaded = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.faq {
  width: 90%;
  margin: 0 auto;
  padding: 0.5rem 0 0.8rem;
  background: #fff;
  h2 {
    margin: 0.2rem 0 0.1rem;
    font-size: 0.44rem;
    font-weight: 700;
    color: #222222;
  }
  .faq-item {
    padding: 0.4rem 0;
    border-bottom: 1px solid #eeeeee;
    h3 {
      margin: 0;
      font-size: 0.36rem;
      line-height: 0.52rem;
      color: #222222;
      font-weight: 700;
    }
    p {
      margin: 0.2rem 0 0;
      font-size: 0.3rem;
      line-height: 0.48rem;
      color: #888888;
    }
  }
  .empty {
    padding: 0.6rem 0;
    text-align: center;
    color: #999;
    font-size: 0.3rem;
  }
}
</style>
